export default {
  post_structures: `/v1/structures_import`,
  post_positions: `/v1/positions_import`,
  post_staffs: `/v1/staffs_import`,
  get_imports: `/v1/logs/imports`
};
